<p class="mat-body-2">
  In order for us to flag students who are missing prep for a planned exam, we need an accurate list of your prep
  courses. Please review the courses on your master schedule, and assign the exams each course preps for where
  applicable.
</p>

<div>
  <button class="step-action-button" mat-raised-button (click)="goToMasterProgram()"> Review Prep Courses </button>
</div>